import type { Faro } from "@grafana/faro-react";
import {
  initializeFaro as coreInit,
  getWebInstrumentations,
} from "@grafana/faro-react";
import {
  TracingInstrumentation,
  getDefaultOTELInstrumentations,
} from "@grafana/faro-web-tracing";

export const initializeFaro = (): Faro | undefined => {
  const VITE_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
  const VITE_GRAFANA_ALLOY_API_KEY = import.meta.env.VITE_GRAFANA_ALLOY_API_KEY;

  if (VITE_ENVIRONMENT === "local") {
    return;
  }

  const faro = coreInit({
    url: "/collect",
    apiKey: VITE_GRAFANA_ALLOY_API_KEY,
    batching: {
      enabled: true,
      sendTimeout: 30000, // 30 seconds
    },
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: true,
      }),
      new TracingInstrumentation({
        instrumentations: [...getDefaultOTELInstrumentations()],
      }),
    ],
    sessionTracking: {
      enabled: true,
      session: (window as any).__PRELOADED_STATE__?.faro?.session,
    },
    app: {
      name: "dualis-frontend-" + VITE_ENVIRONMENT,
      version: "0.0.1",
      environment: VITE_ENVIRONMENT,
    },
  });

  faro.api.pushLog(["Faro was initialized"]);

  return faro;
};
